import styled from "styled-components";
import { colors, text, values } from "~/assets/js/theme/constants";

export const StyledButton = styled.div`
    border-radius: 50px;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    background-color: ${colors.BRAND.PRIMARY[100]};
    &:hover {
        background-color: ${colors.BRAND.PRIMARY[700]};
    }
    transition: ${values.DEFAULT_TRANSITION_DURATION};
    padding: 6px;
    padding-right: 20px;
    cursor: pointer;
    margin-right: 12px;

    @media screen and (min-width: ${values.VIEW_PORT_LAPTOP}) {
        padding-right: 16px;
    }

    @media screen and (min-width: ${values.VIEW_PORT_DESKTOP}) {
        padding-right: 20px;
    }
`;

export const Text = styled.div`
    color: ${colors.LAYOUT.GRAY[1000]};
    font-weight: ${text.BOLD.WEIGHT};
    font-family: ${text.BOLD.FONT};
    margin-left: 12px;
    font-size: 18px;
    text-align: right;
`;
